export class EntryPagePreferences {
	tabId?: string;
}
